import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Layout from '~/Components/Layout/Layout';
import ProfilePopupForm from '../../Components/Forms/ProfilePopupForm/ProfilePopupForm';
import { ArrowBackIcon } from '../../Components/Icons/Icons';
import ProfilePopup from '../../Components/ProfilePopup/ProfilePopup';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import {setMyAccountPopupState} from '../../redux/actions/general';

function MyProfile ({user, ...props}) {
	const [success, setSuccess] = useState('');
	const [errors, setErrors] = useState(null);

	const history = useHistory();

    useEffect(()=>{
        setForm({
			first_name: user.first_name,
			last_name: user.last_name,
			email: user.email,
			phone: user.phone,
        })
    }, [user]);

    const [form, setForm] = useState({
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone: user.phone,
    });

    const handleClosePopup = () => {
		props.dispatch(setMyAccountPopupState(false))
		history.goBack();
    }

	return (
		<Layout noPadding>
			<div className="container">
				<ProfilePopup />

				<div className="profile-popup">
					<div className="popup-close my-4">
						<button className="btn btn-secondary btn-sm mb-2" onClick={handleClosePopup}>
							<ArrowBackIcon classes="pr-2 svg-16"/>
							<TextTranslate name="word-back" fallback="Back" textOnly/>
						</button>
					</div>
					<div>
						<h2 className="text-title mb-4"><TextTranslate name="user-my-profile" fallback="My Profile" textOnly/></h2>
					</div>
					<div className="row no-gutters">
						<div className="col-12">
							<h4 className="text-headline text-primary"><TextTranslate name="user-account-details" fallback="Account Details" textOnly/></h4>

							{success && (
								<div className="alert alert-success" role="alert">
									{success}
								</div>
							)}

							{errors?.message && (
								<div className="alert alert-danger" role="alert">
									{errors?.message}
								</div>
							)}

							<ProfilePopupForm
								isSeparatePage={true}
								values={form}
								errors={errors?.errors}
								onChange={(f) => setForm(f)}
							/>
						</div>
					</div>
				</div>

			</div>
		</Layout>
	)
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    isShown: state.general.myProfileOpen,
});

export default connect(mapStateToProps)(MyProfile);
